const SITE = 'https://api.niggle.ie';

const statusData = [
    { id: 1, name: 'New', color: '#d9534f', icon: 'Plus' },
    { id: 2, name: 'Assigned', color: '#337ab7', icon: 'User' },
    { id: 3, name: 'In progress', color: '#A163D1', icon: 'RefreshCw' },
    { id: 4, name: 'On hold', color: '#f0ad4e', icon: 'Pause' },
    { id: 5, name: 'Closed', color: '#5cb85c', icon: 'Check'}
];

const STATUSES = {
  1: statusData[0],
  2: statusData[1],
  3: statusData[2],
  4: statusData[3],
  5: statusData[4],
};

const STATUSES_ORDER = [2,5,3,1,4];


const ROLES = {
  0: { id: 0, name: 'User', color: '#d9534f' },
  1: { id: 1, name: 'Resource', color: '#d9534f' },
  2: { id: 2, name: 'Manager', color: '#d9534f' },
  3: { id: 3, name: 'Admin', color: '#d9534f' },
};

const REPORTS = {   
  "1": { qid: 1, reportName: "Jobs by resource", title: "Resource", apiField: "assignee", queryField: "assigned_to", dataType: 1},
  "2": { qid: 2, reportName: "Jobs by type", title: "Type", apiField: "type", queryField: "type_id", dataType: 1 },
  "3": { qid: 3, reportName: "Jobs by location", title: "Location", apiField: "location", queryField: "location_id", dataType: 1 },
  "4": { qid: 4, reportName: "Jobs by requester", title: "User", apiField: "user", queryField: "user_id", dataType: 1 },
  "5": { qid: 5, reportName: "Open jobs ageing by type", title: "Type", apiField: "type", queryField: "type_id", dataType: 2 },
  "6": { qid: 6, reportName: "Open jobs ageing by resource", title: "Resource", apiField: "assignee", queryField: "assigned_to", dataType: 2 }, 
  "7": { qid: 7, reportName: "Open jobs ageing by location", title: "Location Meta", apiField: "location_meta", queryField: "location_meta", dataType: 2 },
  "8": { qid: 1, reportName: "Handyman", title: "Resource", apiField: "assignee", queryField: "assigned_to", dataType: 1, detailsPage: "handyman/1"},
  "9": { qid: 9, reportName: "Export", title: "Export" },
  "10": { qid: 10, reportName: "Jobs by sub location", title: "Sub Location", apiField: "location_meta", queryField: "location_meta", dataType: 1 },
};
const REPORT_AGES = {
  "1": {from: 0, to: 6, title: "0-6 Days"},
  "2": {from: 6, to: 11, title: "6-11 Days"},
  "3": {from: 11, to: 21, title: "11-21 Days"},
  "4": {from: 21, to: 51, title: "21-51 Days"},
  "5": {from: 51, to: 101, title: "51-101 Days"},
  "6": {from: 101, to: 1001, title: "100+ Days"},
};


const API = {
  SITE,
  ENDPOINTS: {
    AUTH: `${SITE}/auth/login`,
    USERS: `${SITE}/api/users`,
    JOBS: `${SITE}/api/jobs`,
    TYPES: `${SITE}/api/types`,
    LOCATIONS: `${SITE}/api/locations`,
    SUBLOCATIONS: `${SITE}/api/sub_locations`,
    STATS: `${SITE}/api/stats`,
    COMPANIES: `${SITE}/api/companies`,
    RESET: `${SITE}/auth/reset`,
    REQUEST_RESET: `${SITE}/auth/request_reset`,
  },
  STATUSES,
  STATUSES_ORDER,
  ROLES,
  STATUSES_DENORMALIZED: statusData,
  REPORTS,
  REPORT_AGES

};

export default API;



// WEBPACK FOOTER //
// ./src/Configs/index.js